import React, { useEffect, useState } from 'react';
import { Button } from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getTheme } from '../../../../constants/theme';

const palette = ({ theme }) => theme.navigation || getTheme('bright').navigation;
const Choices = styled.fieldset`
  border: 0;
  padding: 0;
  margin: 0 0 1em;
  min-width: 0;
  legend { font-weight: 600; font-size: 1.1em; margin-bottom: 0.75em; }
`;
const Choice = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75em;
  padding: 0.9em 1em;
  margin: 0.6em 0;
  border: 1px solid ${props => palette(props).border};
  border-radius: 10px;
  background: ${props => props.$selected ? palette(props).activeBackground : palette(props).surface};
  color: ${props => props.$selected ? palette(props).activeText : palette(props).text};
  cursor: pointer;
  input { flex-shrink: 0; accent-color: ${props => palette(props).accent}; }
  &:focus-within { outline: 2px solid ${props => palette(props).focus}; outline-offset: 2px; }
`;

export const AiManuscriptPreference = ({ initialValue, onUpdate, updating, wizardMode, t }) => {
  const [value, setValue] = useState(initialValue);
  useEffect(() => setValue(initialValue), [initialValue]);
  const hasChoice = typeof value === 'boolean';
  return (
    <form onSubmit={event => {
      event.preventDefault();
      if (hasChoice && !updating) onUpdate({ showAiGeneratedManuscripts: value });
    }}>
      <Choices disabled={updating}>
        <legend>{t('AiManuscriptPreferenceQuestion')}</legend>
        <p>{t('AiManuscriptPreferenceDescription')}</p>
        {[true, false].map(choice => (
          <Choice key={String(choice)} $selected={value === choice}>
            <input type="radio" name="ai-manuscript-preference"
              checked={value === choice} onChange={() => setValue(choice)} />
            <span>{t(choice ? 'AiManuscriptPreferenceYes' : 'AiManuscriptPreferenceNo')}</span>
          </Choice>
        ))}
      </Choices>
      <p>{t('AiManuscriptPreferenceChangeLater')}</p>
      <Button type="submit" aria-busy={updating}
        disabled={updating || !hasChoice || (!wizardMode && value === initialValue)}>
        {t(wizardMode ? 'Next' : 'Save')}
      </Button>
      {!wizardMode && hasChoice && value === initialValue && !updating && (
        <span role="status" style={{ marginLeft: '0.75em' }}>{t('AiManuscriptPreferenceSaved')}</span>
      )}
    </form>
  );
};

export default withTranslation()(AiManuscriptPreference);
